// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4zdNt","delete":"styles_delete__1fL22","update":"styles_update__1Nzn-","add":"styles_add__3kbNB"};